import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import Select from "react-select";
import { Row, Col } from "reactstrap";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import CustomLoader from "../static/CustomLoader";
import {
  uploadDocument,
  viewDocument,
  deleteDocument,
} from "../utiles/DocumentService";

const NAVY = "#123B5D";
const BORDER = "#DCE4EC";

const uploadButtonSx = {
  height: 38,
  borderRadius: "8px",
  borderColor: "#B9C8D6",
  color: NAVY,
  fontSize: 12.5,
  fontWeight: 600,
  textTransform: "none",
  backgroundColor: "#FFFFFF",
  "&:hover": {
    borderColor: NAVY,
    backgroundColor: "#F4F8FB",
  },
};

const NearMissAccident = ({
  selectedId,
  mode,
  onHide,
  setRefresh,
  deptcodeList,
  usedCodeList,
  statusOptions,
}) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";

  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [startdatetime, setStartdatetime] = useState("");
  const [enddatetime, setEnddatetime] = useState("");
  const [divcode, setDivcode] = useState("");
  const [location, setLocation] = useState("");
  const [accidentinfo, setAccidentinfo] = useState("");
  const [user, setUser] = useState("");
  const [updatecomment, setUpdatecomment] = useState("");
  const [createimpaths, setCreateimpaths] = useState("");
  const [updateimgpaths, setUpdateimgpaths] = useState("");
  const [status, setStatus] = useState("");
  const [createimpathsPreview, setCreateimpathsPreview] = useState([]);
  const [updateimgpathsPreview, setUpdateimgpathsPreview] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  const getMimeType = (name = "") => {
    const ext = name.split(".").pop().toLowerCase();
    if (ext === "pdf") return "application/pdf";
    if (ext === "png") return "image/png";
    if (ext === "gif") return "image/gif";
    if (ext === "webp") return "image/webp";
    return "image/jpeg";
  };

  const fetchMultipleImages = async (fileNamesCSV, type, code1) => {
    if (!fileNamesCSV) {
      if (type === "create") setCreateimpathsPreview([]);
      else setUpdateimgpathsPreview([]);
      return;
    }

    const fileNames = fileNamesCSV
      .split(",")
      .map((n) => n.trim())
      .filter(Boolean);
    const folderPath = `${orgcode}/sl_${code1}`;
    const previews = [];
    setLoading(true);

    for (const name of fileNames) {
      try {
        const response = await viewDocument({
          projectCode: "Ptw",
          envCode,
          folderPath,
          fileName: name,
        });

        // error object or empty -> keep the slot so indexes still match filenames
        if (!response || response.cd === 1 || typeof response !== "string") {
          previews.push(null);
          continue;
        }

        const binary = atob(response);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

        const blob = new Blob([bytes], { type: getMimeType(name) });
        previews.push(URL.createObjectURL(blob));
      } catch (err) {
        console.warn(`Failed to fetch image: ${name}`, err);
        previews.push(null);
      }
    }

    setLoading(false);

    if (type === "create") setCreateimpathsPreview(previews);
    else setUpdateimgpathsPreview(previews);
  };
  const handleUploadMultiple = async (files, type) => {
    if (!files || files.length === 0) {
      toast.warning("No file(s) selected.");
      return;
    }

    const folderPath = `${orgcode}/sl_${code}`;
    const maxRetries = 3;
    const uploadedFiles = [];
    const previewURLs = [];

    setLoading(true);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!["image/png", "image/jpeg"].includes(file.type)) {
        toast.warning(`${file.name} is not a valid JPG/PNG file.`);
        continue;
      }

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          setLoading(true);

          const uploadRes = await uploadDocument({
            file,
            projectCode: "Ptw",
            envCode,
            folderPath,
          });

          if (uploadRes?.cd === 1) {
            toast.error(uploadRes.description);
            setLoading(false);
            return;
          }

          uploadedFiles.push(uploadRes);

          const fileURL = URL.createObjectURL(file);
          previewURLs.push(fileURL);

          break;
        } catch (error) {
          console.warn(
            `Upload attempt ${attempt} for ${file.name} failed`,
            error,
          );

          if (attempt === maxRetries) {
            toast.error(`Upload failed for ${file.name}`);
          } else {
            await new Promise((res) => setTimeout(res, 2000 * attempt));
          }
        } finally {
          setLoading(false);
        }
      }
    }

    if (uploadedFiles.length > 0) {
      toast.success("Upload(s) successful!");
      const csv = uploadedFiles.join(",");

      if (type === "create") {
        setCreateimpaths((prev) => (prev ? `${prev},${csv}` : csv));
        setCreateimpathsPreview((prev) => [...prev, ...previewURLs]);
      } else {
        setUpdateimgpaths((prev) => (prev ? `${prev},${csv}` : csv));
        setUpdateimgpathsPreview((prev) => [...prev, ...previewURLs]);
      }
    }

    setLoading(false);
  };

  const deleteImage = async (filename, type) => {
    const folderPath = `${orgcode}/sl_${code}`;

    try {
      setLoading(true);

      const response = await deleteDocument({
        projectCode: "Ptw",
        envCode: envCode,
        folderPath: folderPath,
        fileName: filename,
      });

      if (response && response.cd === 1) {
        console.log(response.description);
      }

      toast.success(`Deleted: ${filename}`);

      if (type === "create") {
        setCreateimpaths((prev) =>
          prev
            .split(",")
            .filter((f) => f !== filename)
            .join(","),
        );

        setCreateimpathsPreview((prev) => {
          const index = createimpaths.split(",").indexOf(filename);

          return prev.filter((_, i) => i !== index);
        });
      } else {
        setUpdateimgpaths((prev) =>
          prev
            .split(",")
            .filter((f) => f !== filename)
            .join(","),
        );

        setUpdateimgpathsPreview((prev) => {
          const index = updateimgpaths.split(",").indexOf(filename);

          return prev.filter((_, i) => i !== index);
        });
      }
    } catch (err) {
      console.error("Delete failed:", err);
      toast.error("Failed to delete file.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedId !== "") {
      const fetchNearmissData = async () => {
        try {
          setLoading(true);

          const response = await axios.post(
            `${apiUrl}nearMissaccident/id/${selectedId}`,
            null,
            { headers },
          );

          if (response.data.cd === 1) {
            toast.info(response.data.description);
          } else {
            setId(response.data.id);
            setCode(response.data.code);
            setStartdatetime(response.data.startdatetime);
            setEnddatetime(response.data.enddatetime);
            setDivcode(response.data.divcode);
            setLocation(response.data.location);
            setAccidentinfo(response.data.accidentinfo);
            setUser(response.data.user);
            setCreateimpaths(response.data.createimpaths);
            setUpdatecomment(response.data.updatecomment);
            setUpdateimgpaths(response.data.updateimgpaths);
            setStatus(response.data.status);

            if (
              response.data.createimpaths ||
              response.data.createimpaths !== null
            ) {
              fetchMultipleImages(
                response.data.createimpaths,
                "create",
                response.data.code,
              );
            }

            if (
              response.data.updateimgpaths ||
              response.data.updateimgpaths !== null
            ) {
              fetchMultipleImages(
                response.data.updateimgpaths,
                "update",
                response.data.code,
              );
            }
          }
        } catch (error) {
          console.error("Error in useEffect:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchNearmissData();
    }
  }, [selectedId]);

  const handlesubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const response = await axios.put(
        apiUrl + "nearMissaccident",
        {
          id: id,
          code: code,
          startdatetime: startdatetime,
          enddatetime: enddatetime,
          divcode: divcode,
          location: location,
          accidentinfo: accidentinfo,
          user: user,
          createimpaths: createimpaths,
          updatecomment: updatecomment,
          updateimgpaths: updateimgpaths,
          status: status,
        },
        { headers },
      );

      if (response.data.cd === 1) {
        setSucessMessage(response.data.description);
        setTitle("⚠️ Failed");
        setShowSucessModal(true);
      } else {
        setId(response.data.id);
        setCode(response.data.code);
        setStartdatetime(response.data.startdatetime);
        setEnddatetime(response.data.enddatetime);
        setDivcode(response.data.divcode);
        setLocation(response.data.location);
        setAccidentinfo(response.data.accidentinfo);
        setUser(response.data.user);
        setCreateimpaths(response.data.createimpaths);
        setUpdatecomment(response.data.updatecomment);
        setUpdateimgpaths(response.data.updateimgpaths);
        setStatus(response.data.status);

        if (response.data.createimpaths) {
          fetchMultipleImages(
            response.data.createimpaths,
            "create",
            response.data.code,
          );
        }

        if (response.data.updateimgpaths) {
          fetchMultipleImages(
            response.data.updateimgpaths,
            "update",
            response.data.code,
          );
        }

        toast.success("Safety logs  updated successfully!");
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = (selectedStatus) => {
    if (selectedStatus) {
      const selectedTypeStatus = selectedStatus.value;
      setStatus(selectedTypeStatus);
    } else {
      setStatus("");
    }
  };

  const handleEmpCode = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setUser(selectedTypeValue);
    } else {
      setUser("");
    }
  };

  const handleDepCode = (selectedOption) => {
    if (selectedOption) {
      const selectedTypeValue = selectedOption.value;
      setDivcode(selectedTypeValue);
    } else {
      setDivcode("");
    }
  };

  return (
    <>
      {loading && <CustomLoader />}

      <SucessModal
        show={ShowSucessModal}
        onClose={handleCloseSucessModal}
        headerText={titile}
        message={SucessMessage}
      />

      <div className="popupmodal-maindiv">
        <Row>
          <Col md={4}>
            <div className="form-group">
              <label>Code</label>
              <input
                type="text"
                readOnly
                placeholder="Enter Code"
                required
                value={code ?? ""}
                onChange={(e) => setCode(e.target.value)}
                className="form-control"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>Start Date</label>
              <input
                type="datetime-local"
                required
                value={startdatetime ?? ""}
                onChange={(e) => setStartdatetime(e.target.value)}
                className="form-control"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>End Date</label>
              <input
                type="datetime-local"
                required
                value={enddatetime ?? ""}
                onChange={(e) => setEnddatetime(e.target.value)}
                className="form-control"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>User</label>
              <Select
                isClearable
                name="User"
                value={usedCodeList.find((option) => option.value === user)}
                onChange={handleEmpCode}
                placeholder="Select User"
                options={usedCodeList}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>Department</label>
              <Select
                isClearable
                name="Department"
                value={deptcodeList.find((option) => option.value === divcode)}
                onChange={handleDepCode}
                placeholder="Select Department"
                options={deptcodeList}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>Status</label>
              <Select
                isClearable
                name="Status"
                value={statusOptions.find((option) => option.value === status)}
                onChange={handleStatus}
                placeholder="Select Status"
                options={statusOptions}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                classNamePrefix="select"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>Location</label>
              <input
                type="text"
                placeholder="Enter Location"
                required
                value={location ?? ""}
                onChange={(e) => setLocation(e.target.value)}
                className="form-control"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>Accident Info</label>
              <input
                type="text"
                readOnly
                placeholder="Enter Accident Info"
                value={accidentinfo ?? ""}
                onChange={(e) => setAccidentinfo(e.target.value)}
                className="form-control"
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="form-group">
              <label>Comment</label>
              <input
                type="text"
                placeholder="Enter Comment"
                required
                value={updatecomment ?? ""}
                onChange={(e) => setUpdatecomment(e.target.value)}
                className="form-control"
              />
            </div>
          </Col>
        </Row>

        <Box
          sx={{
            mt: 0.5,
            pt: 1.5,
            borderTop: `1px solid ${BORDER}`,
          }}
        >
          <Row>
            <Col md={6}>
              <Box
                sx={{
                  border: "1px dashed #C9D6E2",
                  borderRadius: "8px",
                  p: 1.25,
                  backgroundColor: "#FAFCFE",
                }}
              >
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  disabled={loading}
                  sx={uploadButtonSx}
                >
                  Created Impacts (JPG/PNG)
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    multiple
                    hidden
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      handleUploadMultiple(files, "create");
                    }}
                  />
                </Button>

                {createimpathsPreview.length > 0 && (
                  <Box
                    sx={{
                      mt: 1.5,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1.5,
                    }}
                  >
                    {createimpathsPreview.map((url, idx) => {
                      if (!url) return null;
                      const filenames = createimpaths.split(",");
                      return (
                        <Box
                          key={idx}
                          sx={{
                            width: {
                              xs: "100%",
                              sm: 145,
                            },
                            border: `1px solid ${BORDER}`,
                            borderRadius: "8px",
                            p: 0.75,
                            backgroundColor: "#FFFFFF",
                          }}
                        >
                          <Box
                            component="img"
                            src={url}
                            alt={`Created Preview ${idx + 1}`}
                            sx={{
                              width: "100%",
                              height: 100,
                              objectFit: "cover",
                              borderRadius: "6px",
                              cursor: "pointer",
                              display: "block",
                            }}
                            onClick={() => {
                              setPreviewImage(url);
                              setIsPreviewOpen(true);
                            }}
                          />

                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            fullWidth
                            sx={{
                              mt: 0.75,
                              height: 30,
                              borderRadius: "6px",
                              fontSize: 11.5,
                              textTransform: "none",
                            }}
                            onClick={() =>
                              deleteImage(filenames[idx], "create")
                            }
                          >
                            Delete Image
                          </Button>
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>
            </Col>

            <Col md={6}>
              <Box
                sx={{
                  border: "1px dashed #C9D6E2",
                  borderRadius: "8px",
                  p: 1.25,
                  backgroundColor: "#FAFCFE",
                }}
              >
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  disabled={loading}
                  sx={uploadButtonSx}
                >
                  Updated Impacts (JPG/PNG)
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    multiple
                    hidden
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      handleUploadMultiple(files, "update");
                    }}
                  />
                </Button>

                {updateimgpathsPreview.length > 0 && (
                  <Box
                    sx={{
                      mt: 1.5,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1.5,
                    }}
                  >
                    {updateimgpathsPreview.map((url, idx) => {
                      if (!url) return null;
                      const filenames = updateimgpaths.split(",");

                      return (
                        <Box
                          key={idx}
                          sx={{
                            width: {
                              xs: "100%",
                              sm: 145,
                            },
                            border: `1px solid ${BORDER}`,
                            borderRadius: "8px",
                            p: 0.75,
                            backgroundColor: "#FFFFFF",
                          }}
                        >
                          <Box
                            component="img"
                            src={url}
                            alt={`Updated Preview ${idx + 1}`}
                            sx={{
                              width: "100%",
                              height: 100,
                              objectFit: "cover",
                              borderRadius: "6px",
                              cursor: "pointer",
                              display: "block",
                            }}
                            onClick={() => {
                              setPreviewImage(url);
                              setIsPreviewOpen(true);
                            }}
                          />

                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            fullWidth
                            sx={{
                              mt: 0.75,
                              height: 30,
                              borderRadius: "6px",
                              fontSize: 11.5,
                              textTransform: "none",
                            }}
                            onClick={() =>
                              deleteImage(filenames[idx], "update")
                            }
                          >
                            Delete Image
                          </Button>
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>
            </Col>
          </Row>
        </Box>

        <div className="bottombtn">
          <button
            className="btn btn-success"
            disabled={loading}
            onClick={handlesubmit}
          >
            Save
          </button>
          <button className="btn btn-danger" onClick={handleCloseSucessModal}>
            Close
          </button>
        </div>
      </div>

      {isPreviewOpen && (
        <Box
          onClick={() => setIsPreviewOpen(false)}
          sx={{
            position: "fixed",
            inset: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(8,22,35,0.82)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "pointer",
            p: 2,
            boxSizing: "border-box",
          }}
        >
          <Box
            component="img"
            src={previewImage}
            alt="Full Preview"
            sx={{
              maxWidth: "92%",
              maxHeight: "92%",
              borderRadius: "10px",
              boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
              objectFit: "contain",
              backgroundColor: "#FFFFFF",
            }}
          />
        </Box>
      )}
    </>
  );
};

export default NearMissAccident;
